"use client";

import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from "@/components/ui/hover-card";
import { searchProfile } from "@/lib/account/profile";
import type { EnrichedProfile } from "@/lib/supabase/types";
import { useCallback, useState } from "react";
import { HoverCardProfile2 } from "../account/profile/profile-hover-card";

interface MentionHoverCardProps {
	username: string;
	children: React.ReactNode;
}

export function MentionHoverCard({
	username,
	children,
}: MentionHoverCardProps) {
	const [user, setUser] = useState<EnrichedProfile | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const fetchUser = useCallback(async () => {
		if (user || isLoading) return;

		setIsLoading(true);
		try {
			const { data } = await searchProfile(username);
			if (data && data.length > 0) {
				setUser(data[0]);
			}
		} catch (error) {
			console.error("Error fetching user:", error);
		} finally {
			setIsLoading(false);
		}
	}, [username, user, isLoading]);

	if (user) {
		return (
			<HoverCardProfile2
				variant="link"
				className="inline-flex"
				profile={user}
				onMouseEnter={fetchUser}
			/>
		);
	}

	return (
		<HoverCard>
			<HoverCardTrigger
				asChild
				onMouseEnter={fetchUser}
				className="inline-flex text-link underline-offset-4"
			>
				{children}
			</HoverCardTrigger>
			<HoverCardContent className="w-auto">
				{isLoading ? (
					<div className="p-4 text-center">Loading...</div>
				) : (
					<div className="p-4 text-center">User not found</div>
				)}
			</HoverCardContent>
		</HoverCard>
	);
}
